import { useEffect, useState } from 'react';

import {
  BuyerIntentLeadClick,
  normalizeBuyerIntentId,
  warnMissingBuyerIntentIds,
} from 'components/BuyerIntent';
import createTagScript from 'helpers/createTagScript';
import {
  capturePplCtaEvent,
  withExitIntentEngagementComponent,
  withPplCtaTracking,
} from 'shared-utils/lasTracking';

const PricingPPLWrapper = ({
  globalProductId,
  globalCategoryId,
  hasPplExitIntentEnabled,
  buyerIntentSourceLocation = 'product-info-card:get-price',
  children,
}) => {
  const [utmSource, setUtmSource] = useState(null);
  const [utmMedium, setUtmMedium] = useState(null);
  const buyerIntentProductId = normalizeBuyerIntentId(globalProductId);
  const buyerIntentCategoryId = normalizeBuyerIntentId(globalCategoryId);

  useEffect(() => {
    if (typeof window !== 'undefined' && window.localStorage) {
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      const trackingParams = JSON.parse(
        localStorage.getItem('tracking_params') || '{}'
      );
      const landingPageUrl = trackingParams['landing_page_url'];
      const referrerUrl = trackingParams['referrer_url'];

      if (
        !(
          urlParams.get('utm_source') ||
          urlParams.get('utm_medium') ||
          urlParams.get('utm_campaign')
        ) &&
        landingPageUrl
      ) {
        const landingPageUrlQueryString = landingPageUrl.split('?')[1];
        const landingPageUrlParams = new URLSearchParams(
          landingPageUrlQueryString
        );

        if (
          !(
            landingPageUrlParams.get('utm_source') ||
            landingPageUrlParams.get('utm_medium') ||
            landingPageUrlParams.get('utm_campaign')
          )
        ) {
          if (referrerUrl) {
            setUtmSource(
              referrerUrl.match(/(?:http(?:s)?:\/\/)?(?:w{3}\.)?([^.]+)/i)[1]
            );
            setUtmMedium('organic');
          } else {
            setUtmSource('direct');
            setUtmMedium('none');
          }
        }
      }
    }
  }, [setUtmSource, setUtmMedium]);

  const lasModalParams = {
    brand: 'getapp',
    pGuid: globalProductId,
    cGuid: globalCategoryId,
    formTemplate: 'price',
    isPPL: true,
  };

  if (utmSource && utmMedium) {
    lasModalParams['tracking'] =
      `utm_medium=${utmMedium}&utm_source=${utmSource}`;
  }

  useEffect(() => {
    createTagScript(
      'lead-acquisition-service',
      `https://lead-acquisition-service.getapp.com/las-form-min.js`
    );
  }, []);

  useEffect(() => {
    if (!hasPplExitIntentEnabled) {
      return;
    }
    const current = setTimeout(() => {
      window['addLasExitIntent'] &&
        window['addLasExitIntent'](
          withExitIntentEngagementComponent({
            brand: 'getapp',
            cGuid: globalCategoryId,
            isPPL: true,
            ...(utmSource && utmMedium
              ? { tracking: `utm_medium=${utmMedium}&utm_source=${utmSource}` }
              : {}),
          })
        );
    }, 800);

    return () => clearTimeout(current);
  }, [globalCategoryId, utmSource, utmMedium, hasPplExitIntentEnabled]);

  const openLasModal = (event) => {
    capturePplCtaEvent(event);
    window['openLasModal'](withPplCtaTracking(lasModalParams));
  };

  if (!buyerIntentProductId) {
    warnMissingBuyerIntentIds('pricing-ppl-wrapper:get-price', {
      productId: globalProductId,
      categoryId: globalCategoryId,
    });
  }

  return (
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    <div onClick={openLasModal}>
      {buyerIntentProductId ? (
        <BuyerIntentLeadClick
          productId={buyerIntentProductId}
          categoryId={buyerIntentCategoryId}
          sourceLocation={buyerIntentSourceLocation}
        >
          {children}
        </BuyerIntentLeadClick>
      ) : (
        children
      )}
    </div>
  );
};

export default PricingPPLWrapper;
